// viva_ui/src/Reports/ReportsUser.js


import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Filters from './Filters';
import Table from './Table';
import Dialogs from './Dialogs';
import REPORTS_URL from '../config';
import AttemptDropdown from './AttemptDropdown';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';

export const ReportsUser = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilters, setStatusFilters] = useState([]);
  const [departmentFilters, setDepartmentFilters] = useState([]);
  const [assignedFilters, setAssignedFilters] = useState([]);
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [rescheduleOpen, setRescheduleOpen] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [newDateTime, setNewDateTime] = useState('');
  const [newEndDateTime, setNewEndDateTime] = useState('');
  const [viewType, setViewType] = useState("completed");
  const [pendingDialogOpen, setPendingDialogOpen] = useState(false);
  const [groupEmployeeFilter, setGroupEmployeeFilter] = useState(null);
  const [groupFilterMessage, setGroupFilterMessage] = useState("");
  const [selectedAttempt, setSelectedAttempt] = useState("all");

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // const examId = params.get("examId");
  const examType = params.get("examType");

  const coursePage = params.get("coursePage");

  const examTitle = params.get("examTitle");
  console.log("examType:", examType);

  // New state for QueryBuilder rule
  const [filterRule, setFilterRule] = useState(null);

  const examId = new URLSearchParams(window.location.search).get('examId');
  console.log("examId:", examId);

  const buildReportParams = (pageNum = 1, pageSizeOverride = pageSize) => {
    const params = new URLSearchParams({
      exam_id: examId,
      search: searchTerm,
      page: pageNum,
      page_size: pageSizeOverride,
      attempt: selectedAttempt,
    });
    if (statusFilters.length > 0) params.append('status', statusFilters.join(','));
    if (departmentFilters.length > 0) params.append('department', departmentFilters.join(','));
    if (assignedFilters.length > 0) params.append('assigned', assignedFilters.join(','));
    if (dateRange.from) params.append('date_from', dateRange.from);
    if (dateRange.to) params.append('date_to', dateRange.to);
    if (filterRule && filterRule.rules?.length) {
      params.append('filters', JSON.stringify(filterRule));
    }
    if (groupEmployeeFilter?.groups?.length) {
      params.append('group_employee_filter', JSON.stringify(groupEmployeeFilter));
    }

    return params;
  };

  const fetchReports = async (pageNum = 1) => {
    try {
      setLoading(true);
      const params = buildReportParams(pageNum, pageSize);

      const response = await axios.get(`/reports/employees/?${params.toString()}`, {
        withCredentials: true
      });
      const data = response.data;

      if (response.status < 200 || response.status >= 300) {
        alert(data.error || "Unable to filter reports");
        setReports(data.reports || []);
        setTotalCount(data.total_count || 0);
        setGroupFilterMessage(data.error || "");
        return;
      }

      setReports(data.reports || []);
      console.log(reports, "reports")

      console.log('Fetched user reports data:', data);
      setTotalCount(data.total_count || 0);
      setGroupFilterMessage(data.not_attempted_message || "");
      setPage(pageNum);
    } catch (error) {
      console.error('Error fetching reports:', error);
      setReports([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllFilteredReports = async () => {
    const params = buildReportParams(1, Math.max(totalCount, pageSize));
    const response = await axios.get(`/reports/employees/?${params.toString()}`, {
      withCredentials: true
    });
    const data = response.data;

    if (response.status < 200 || response.status >= 300) {
      throw new Error(data.error || "Unable to fetch reports");
    }

    return data.reports || [];
  };

  useEffect(() => {
    fetchReports(1);
  }, [searchTerm, statusFilters, departmentFilters, assignedFilters, dateRange, filterRule, groupEmployeeFilter, examId, selectedAttempt]);

  const handleGoBack = () => {
    navigate(`/report?page=${coursePage || 1}`);
  };


  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && ['p', 's'].includes(e.key.toLowerCase())) {
        e.preventDefault();
        alert("Printing or saving is disabled for this report.");
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="bgImage">
      <section className="MainSectionTop mt-3">
        <div className="CourseBoxWidth">
          <Box className="CourseBox" sx={{ pl: 3, pr: 3 }}>
            {/* Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
              <button
                type="button"
                className="pd-back-button"
                onClick={handleGoBack}
                aria-label="Go back"
              >
                <i className="fa fa-arrow-circle-left" aria-hidden="true"></i>
              </button>

              <Typography variant="h6">
                Employees Reports
              </Typography>
            </Box>

            {/* Content */}
            <Card sx={{ background: '#fff', borderRadius: 2, boxShadow: 2, mt: 2 }}>


              <CardContent>

                <h2
  style={{
    marginBottom: "1.5rem",
    paddingLeft: "0.25rem",
    fontSize: "clamp(1.2rem, 3vw, 1.5rem)",
    color: "#1f2937",
    fontWeight: 400,
  }}
>
  {/* <span style={{ fontWeight: 600 }}>Exam Title :</span> */}
   {examTitle}
</h2>
                <Filters
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  statusFilters={statusFilters}
                  setStatusFilters={setStatusFilters}
                  departmentFilters={departmentFilters}
                  setDepartmentFilters={setDepartmentFilters}
                  assignedFilters={assignedFilters}
                  setAssignedFilters={setAssignedFilters}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  dropdownOpen={dropdownOpen}
                  setDropdownOpen={setDropdownOpen}
                  filterRule={filterRule}
                  setFilterRule={setFilterRule}   // new prop
                  groupEmployeeFilter={groupEmployeeFilter}
                  setGroupEmployeeFilter={setGroupEmployeeFilter}
                />

                {groupFilterMessage && (
                  <Typography sx={{ mb: 2, color: '#92400e', fontSize: '0.9rem' }}>
                    {groupFilterMessage}
                  </Typography>
                )}

                <Table
                  reports={reports}
                  loading={loading}
                  page={page}
                  setPage={(newPage) => fetchReports(newPage)}
                  rowsPerPage={pageSize}
                  totalCount={totalCount}
                  setPdfUrl={setPdfUrl}
                  setPdfDialogOpen={setPdfDialogOpen}
                  setSelectedEmployee={setSelectedEmployee}
                  setRescheduleOpen={setRescheduleOpen}
                  examType={examType}
                  examId={examId}
                  viewType={viewType}
                  setViewType={setViewType}
                  pendingDialogOpen={pendingDialogOpen}
                  setPendingDialogOpen={setPendingDialogOpen}
                  fetchAllFilteredReports={fetchAllFilteredReports}
                  attemptFilter={
                    <AttemptDropdown
                      value={selectedAttempt}
                      onChange={setSelectedAttempt}
                      latestLabel="Latest Attempts"
                    />
                  }
                />
              </CardContent>
            </Card>
          </Box>

        </div>
      </section>
      <Dialogs
        pdfDialogOpen={pdfDialogOpen}
        setPdfDialogOpen={setPdfDialogOpen}
        pdfUrl={pdfUrl}
        rescheduleOpen={rescheduleOpen}
        setRescheduleOpen={setRescheduleOpen}
        successDialogOpen={successDialogOpen}
        setSuccessDialogOpen={setSuccessDialogOpen}
        selectedEmployee={selectedEmployee}
        newDateTime={newDateTime}
        setNewDateTime={setNewDateTime}
        refreshReports={() => fetchReports(page)}
      // newEndDateTime={newEndDateTime}
      // setNewEndDateTime={setNewEndDateTime}
      />
    </div>
  );
};

